// extracted by mini-css-extract-plugin
export var ignore = "_6o-1";
export var mapping = "_6o-0";
export var range = "_6o-4";
export var savings = "_6o-3";
export var settings = "_6o-2";